import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const axonius = defineConnector({
  identifier: "axonius",
  name: "Axonius",
  tagLine: "Cybersecurity asset management",
  logo,
  protocol: "http",
  tags: ["security"],
  auth: (app) =>
    headerAuth([
      { name: "api-key", value: app.secret.apiKey },
      { name: "api-secret", value: app.secret.apiSecret },
    ]),
  steps: [
    {
      title: "Enter your Axonius instance URL",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          placeholder: "https://yourcompany.axonius.com",
          target: { kind: "configuration", field: "instanceUrl" },
        },
      ],
    },
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Axonius instance and navigate to System Settings > API Clients to create an API client and obtain your credentials.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API secret",
          required: true,
          target: { kind: "secrets", field: "apiSecret" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/settings/meta/about`,
  },
});
